export const cashRegisters = {
  "cashRegister.settingsSync": "Settings synchronization",
  "cashRegister.settingsCurrent": "Current settings confirmed",
  "cashRegister.settingsPending": "Awaiting current settings confirmation",
  "cashRegister.settingsSent": "Settings last sent",
  "cashRegister.settingsAcknowledged": "Settings last acknowledged",
  "cashRegister.firmware": "Firmware",
  "cashRegister.registrationNumber": "Registration number",
  "cashRegister.deviceMode": "Device mode",
  "cashRegister.cashBalance": "Cash in register",
  "cashRegister.ofdPending": "Documents waiting for OFD",
  "cashRegister.ofdOldest": "Oldest document waiting for OFD",
  "cashRegister.lastDocument": "Last device document",
  "cashRegister.lastDocumentAt": "Last device document time",
  "cashRegister.savedRequest": "Saved fiscal request",
  "cashRegister.savedRequestHint": "This is the saved request sent to the device. Fiscal identity below is read from the device; this is not a full image of the printed receipt.",
  "cashRegister.issuerTaxId": "Issuer tax ID",
  "cashRegister.cashier": "Cashier",
  "cashRegister.cashierTaxId": "Cashier tax ID",
  "cashRegister.unsupportedClinic": "Cash registers are not yet available for your clinic.",
  "cashRegister.alreadyFiscalized": "A fiscal document already exists for this financial operation. Inspect the register journal.",
  "cashRegister.sourceMismatch": "The payment or refund belongs to another branch, issuer or currency. Select its matching register.",
  "cashRegister.pairingThrottled": "A code was issued less than a minute ago. Wait one minute before requesting another.",
  "cashRegister.transferRequired": "This register is already paired. Transfer it in the register card before pairing another workstation.",
  "cashRegister.unresolved": "An operation or paper printing remains unfinished. Resolve it in the journal and tray component.",
  "cashRegister.evidenceConflict": "The document evidence conflicts with the operation or another recorded document. Check the original fiscal evidence.",
  "cashRegister.noEffect": "Absence of a document does not prove that no fiscal operation occurred. Obtain device evidence before resolving the outcome.",
  "cashRegister.alreadyResolved": "This operation no longer requires reconciliation. Refresh its journal entry.",
  "cashRegister.deviceAssigned": "This physical device is already assigned. Transfer its current register before connecting it here.",
  "cashRegister.notReady": "The equipment is not ready. Check the driver, device and fiscal state.",
  "cashRegister.shiftRequired": "An open, unexpired shift is required for this operation.",
  "cashRegister.codeInvalid": "The connection code is invalid, expired or already used. Request a new code in the register card.",
  "cashRegister.versionUnsupported": "The local component protocol is incompatible. Install the published component version.",
  "cashRegister.pending": "Submitting…",
  "cashRegister.createHolding": "Enter a register name and choose a branch.",
  "cashRegister.vat.none": "No VAT",
  "cashRegister.vat.vat0": "0%",
  "cashRegister.vat.vat5": "5%",
  "cashRegister.vat.vat7": "7%",
  "cashRegister.vat.vat10": "10%",
  "cashRegister.vat.vat20": "20%",
  "cashRegister.vat.vat22": "22%",
  "cashRegister.vat.vat105": "5/105",
  "cashRegister.vat.vat107": "7/107",
  "cashRegister.vat.vat110": "10/110",
  "cashRegister.vat.vat120": "20/120",
  "cashRegister.vat.vat122": "22/122",
  "cashRegister.server": "System HTTPS address",
  "cashRegister.title": "Cash registers",
  "cashRegister.description": "Equipment, workstation connections, shifts and fiscal documents",
  "cashRegister.deviceError": "Device error",
  "cashRegister.noDeviceError": "No error reported",
  "cashRegister.model": "Device model",
  "cashRegister.name": "Register name",
  "cashRegister.itemName": "Item name",
  "cashRegister.branch": "Branch",
  "cashRegister.taxSystem": "Tax system",
  "cashRegister.create": "Create register",
  "cashRegister.save": "Save",
  "cashRegister.cancel": "Cancel",
  "cashRegister.loading": "Loading cash registers…",
  "cashRegister.empty": "No cash registers yet",
  "cashRegister.failed": "Could not complete the cash register action. Refresh the state and check connection and operation evidence.",
  "cashRegister.forbidden": "You do not have permission for this action.",
  "cashRegister.conflict": "The register refused this operation. Check its state and journal.",
  "cashRegister.itemsUnsupported": "The saved financial evidence does not describe a supported fiscal document. Check service positions, allocations, explicit tax and the original fiscal sale for a refund.",
  "cashRegister.unsaved": "Cash register settings have unsaved changes.",
  "cashRegister.state": "State",
  "cashRegister.shift": "Shift",
  "cashRegister.connection": "Connection",
  "cashRegister.install": "Installation disk",
  "cashRegister.openShift": "Open shift",
  "cashRegister.closeShift": "Close shift",
  "cashRegister.journal": "Operation journal",
  "cashRegister.kind": "Operation",
  "cashRegister.amount": "Amount",
  "cashRegister.created": "Recorded",
  "cashRegister.print": "Printing",
  "cashRegister.document": "Fiscal document",
  "cashRegister.refresh": "Refresh",
  "cashRegister.more": "Load more",
  "cashRegister.noBinding": "Not paired",
  "cashRegister.stale": "Observation is stale",
  "cashRegister.agent": "Local component",
  "cashRegister.driver": "Driver",
  "cashRegister.device": "Device",
  "cashRegister.fiscal": "Fiscal readiness",
  "cashRegister.paper": "Paper",
  "cashRegister.ofd": "OFD exchange",
  "cashRegister.observed": "Last observation",
  "cashRegister.machine": "Workstation",
  "cashRegister.serial": "Device serial",
  "cashRegister.storage": "Fiscal storage serial",
  "cashRegister.reason": "Reason",
  "cashRegister.rename": "Rename",
  "cashRegister.transfer": "Transfer to another workstation",
  "cashRegister.archive": "Archive register",
  "cashRegister.drainHint": "Uncertain operations and unfinished printing block transfer. Finish reconciliation, then repeat transfer.",
  "cashRegister.installSteps": "Install the Windows component, open it from the tray and paste the connection code from this page. Configure the equipment in the vendor’s driver test tool. This page shows observations received after pairing.",
  "cashRegister.install.getComponent": "Download the component",
  "cashRegister.install.runInstaller": "Install it on the workstation",
  "cashRegister.install.connect": "Connect the workstation to the system",
  "cashRegister.install.verify": "Check the equipment",
  "cashRegister.install.version": "Component version",
  "cashRegister.install.size": "Installer size",
  "cashRegister.install.checksum": "Installer SHA-256",
  "cashRegister.install.distributionFailed": "Could not read the published component. Repeat the request; the register itself is unaffected.",
  "cashRegister.country": "Country profile",
  "cashRegister.countryLimited": "Cash equipment currently supports the Russian RU/RUB fiscal rules.",
  "cashRegister.unsigned": "The installer is unsigned. Windows may warn about the publisher or block it under workstation policy. HTTPS and the SHA-256 manifest protect download integrity.",
  "cashRegister.download": "Download Windows installer",
  "cashRegister.manifest": "Download SHA-256 manifest",
  "cashRegister.vendor.atol": "Atol DTO 10",
  "cashRegister.vendor.shtrih": "Shtrih",
  "cashRegister.vendor": "Install the vendor x86 driver separately",
  "cashRegister.pair": "Generate connection code",
  "cashRegister.code": "Connection code",
  "cashRegister.expires": "Expires",
  "cashRegister.codeHint": "Copy this entire connection code into the local component. It includes the server address, works once and expires after ten minutes.",
  "cashRegister.preview": "Review fiscal document",
  "cashRegister.queue": "Send to register",
  "cashRegister.receiptAction": "Issue fiscal receipt",
  "cashRegister.refundAction": "Issue fiscal refund",
  "cashRegister.sourceHint": "This action fiscalizes the saved financial operation. It does not record another payment or refund.",
  "cashRegister.queued": "Operation saved. Inspect its final result in the register journal.",
  "cashRegister.events": "Operation events",
  "cashRegister.evidence": "Evidence reference",
  "cashRegister.reconcile": "Reconcile using fiscal document",
  "cashRegister.reconcileHint": "Provide the actual device document identity. Absence of a document alone cannot authorize another execution. Paper continuation is performed in the tray component for this existing document only.",
  "cashRegister.number": "Document number",
  "cashRegister.fiscalSign": "Fiscal sign",
  "cashRegister.issuedAt": "Device document time (ISO 8601 with offset)",
  "cashRegister.shiftNumber": "Shift number",
  "cashRegister.back": "Back to register",
  "cashRegister.quantity": "Quantity",
  "cashRegister.vat": "VAT",
  "cashRegister.signal.ready": "Ready",
  "cashRegister.signal.unknown": "Unknown",
  "cashRegister.signal.unavailable": "Unavailable",
  "cashRegister.signal.unsupported": "Unsupported",
  "cashRegister.shift.open": "Open",
  "cashRegister.shift.closed": "Closed",
  "cashRegister.shift.expired": "Expired",
  "cashRegister.shift.unknown": "Unknown",
  "cashRegister.lifecycle.active": "Active",
  "cashRegister.lifecycle.draining": "Finishing admitted operations",
  "cashRegister.lifecycle.archived": "Archived",
  "cashRegister.kind.open_shift": "Open shift",
  "cashRegister.kind.close_shift": "Close shift",
  "cashRegister.kind.sale": "Sale receipt",
  "cashRegister.kind.refund": "Refund receipt",
  "cashRegister.kind.recover": "Recovery",
  "cashRegister.state.queued": "Queued",
  "cashRegister.state.prepared": "Prepared",
  "cashRegister.state.executing": "Execution admitted",
  "cashRegister.state.succeeded": "Fiscal effect confirmed",
  "cashRegister.state.failed": "Failed before fiscal effect",
  "cashRegister.state.outcome_unknown": "Outcome unknown — reconcile before retry",
  "cashRegister.state.cancelled": "Cancelled before admission",
  "cashRegister.print.unknown": "Unknown",
  "cashRegister.print.not_required": "Not required",
  "cashRegister.print.printed": "Printed",
  "cashRegister.print.pending": "Fiscalized; paper printing unfinished",
  "cashRegister.taxSystem.osn": "General taxation",
  "cashRegister.taxSystem.usn_income": "Simplified: income",
  "cashRegister.taxSystem.usn_income_outcome": "Simplified: income minus expenses",
  "cashRegister.taxSystem.esn": "Agricultural tax",
  "cashRegister.taxSystem.patent": "Patent",
} as const
